module.exports = __webpack_public_path__ + "img/DSC_1868.e887a842.JPG";